export interface AppErrorDetails {
  title: string;
  message: string;
  source?: string;
  details?: string[];
}

function getErrorBox(): HTMLElement {
  return document.getElementById('error-panel') as HTMLElement;
}

function getErrorTitle(): HTMLElement {
  return document.getElementById('error-title') as HTMLElement;
}

function getErrorMessage(): HTMLElement {
  return document.getElementById('error-message') as HTMLElement;
}

function getErrorSource(): HTMLElement {
  return document.getElementById('error-source') as HTMLElement;
}

function getErrorDetails(): HTMLElement {
  return document.getElementById('error-details') as HTMLElement;
}

export function showAppError(details: AppErrorDetails): void {
  const panel = getErrorBox();
  getErrorTitle().textContent = details.title;
  getErrorMessage().textContent = details.message;
  getErrorSource().textContent = details.source ?? '';
  const detailsEl = getErrorDetails();
  detailsEl.innerHTML = '';
  for (const item of details.details ?? []) {
    const li = document.createElement('li');
    li.textContent = item;
    detailsEl.appendChild(li);
  }
  panel.classList.add('visible');
}

export function clearAppError(): void {
  const panel = getErrorBox();
  panel.classList.remove('visible');
  getErrorDetails().innerHTML = '';
}

export function errorMessageOf(err: unknown): string {
  if (err instanceof Error) return err.message;
  if (typeof err === 'string') return err;
  try {
    return JSON.stringify(err);
  } catch {
    return String(err);
  }
}

export function installGlobalErrorHandlers(): void {
  window.addEventListener('error', event => {
    showAppError({
      title: 'Runtime Error',
      message: event.message || 'Unexpected runtime error.',
      source: event.filename ? `${event.filename}:${event.lineno}:${event.colno}` : undefined
    });
  });

  window.addEventListener('unhandledrejection', event => {
    showAppError({
      title: 'Unhandled Promise Rejection',
      message: errorMessageOf(event.reason),
      source: 'window.unhandledrejection'
    });
  });
}
